const React = require('react');
const PersonFields = require('../PersonFields');

module.exports = ({activeUserId, formCtx}) => {
  const data = (formCtx.state || {}).data || {};
  const holderIsDirector = data.holder_is_director;

  return (
    <PersonFields
      prefix="director"
      title="Director"
      activeUserId={activeUserId}
      formCtx={formCtx}
      disabled={holderIsDirector}
    />
  )
}
